import { PageMetaData } from '../../components/providers/pageMetaData/pageMetaData';
import { Fullscreen } from './components/Fullscreen';
import { About } from './components/About';
import { Hall } from './components/Hall';
import { Historia } from './components/Historia';
import { Author } from './components/Author';
import { Public } from './components/Public';
import { Digital } from './components/DIgital';
import { Bokey } from './components/Bokey';
import styles from './Museum.module.scss';

export const Museum = ({ pages }) => {
  const upPage = !!pages ? pages.find((el) => el.id === 155) : false;
  const seo = !!upPage ? upPage.acf.seo : false;

  return (
    <>
      {!!seo && <PageMetaData seo={seo} />}
      <main className="main">
        {!!pages ? <Fullscreen upPage={upPage} /> : ''}
        {!!pages ? <About upPage={upPage} /> : ''}
        {!!pages ? <Hall upPage={upPage} /> : ''}
        {!!pages ? <Historia upPage={upPage} /> : ''}
        {!!pages ? <Author upPage={upPage} /> : ''}
        {!!pages ? <Public upPage={upPage} /> : ''}
        {!!pages ? <Digital upPage={upPage} /> : ''}
        {!!pages ? <Bokey upPage={upPage} /> : ''}
      </main>
    </>
  );
};
